import type { Berth, BerthPricePeriod, BerthType } from '@/store/vessel-marinas/vessel-marinas.dto';
import { formatEventDateRange } from '@/utils/formatEventDateRange';

/** The vessel service caps a berth's title here. */
export const TITLE_MAX = 100;

export const BERTH_TYPES: { label: string; value: BerthType }[] = [
  { label: 'Permanent', value: 'permanent' },
  { label: 'Temporary', value: 'temporary' },
];

export const BERTH_TYPE_LABEL: Record<BerthType, string> = {
  permanent: 'Permanent',
  temporary: 'Temporary',
};

export const PRICE_PERIODS: { label: string; value: BerthPricePeriod }[] = [
  { label: 'per hour', value: 'hour' },
  { label: 'per night', value: 'night' },
  { label: 'per week', value: 'week' },
  { label: 'per month', value: 'month' },
  { label: 'per year', value: 'year' },
];

/** The likeliest billing period for each berth type, until the user picks one. */
export const DEFAULT_PRICE_PERIOD: Record<BerthType, BerthPricePeriod> = {
  permanent: 'month',
  temporary: 'night',
};

export const formatBerthDates = ({ dateFrom, dateTo }: Berth) =>
  dateFrom && dateTo ? formatEventDateRange(dateFrom, dateTo) : undefined;

export const formatBerthPrice = ({ price, pricePeriod }: Berth) => {
  if (!price) return undefined;
  const amount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: price.currency,
  }).format(Number(price.amount));
  return pricePeriod ? `${amount} / ${pricePeriod}` : amount;
};

/** Permanent berths lead: the home marina is the one most often reached for. */
export const sortBerths = (berths: Berth[]) =>
  [...berths].sort((a, b) => Number(b.type === 'permanent') - Number(a.type === 'permanent'));
